import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { spacing as sp } from '@metro-ui/tokens/js';
import { responsiveProp, responsivePropTypes, } from '../utils/responsiveProp';
function flexJustify(value) {
    switch (value) {
        case 'start':
            return 'flex-start';
        case 'end':
            return 'flex-end';
        case 'between':
            return 'space-between';
        case 'around':
            return 'space-around';
        case 'evenly':
            return 'space-evenly';
        default:
            return 'center';
    }
}
function flexAlign(value) {
    switch (value) {
        case 'start':
            return 'flex-start';
        case 'end':
            return 'flex-end';
        default:
            return value;
    }
}
function spacingStyle(spacing, direction) {
    switch (direction) {
        case 'column':
            return "0 0 ".concat(sp[spacing], " 0");
        case 'column-reverse':
            return "".concat(sp[spacing], " 0 0 0");
        case 'row-reverse':
            return "0 0 0 ".concat(sp[spacing]);
        default:
            return "0 ".concat(sp[spacing], " 0 0");
    }
}
export var Layout = styled(React.forwardRef(function (_a, ref) {
    var spacing = _a.spacing, gap = _a.gap, grow = _a.grow, shrink = _a.shrink, basis = _a.basis, direction = _a.direction, shouldWrap = _a.shouldWrap, justify = _a.justify, align = _a.align, visibility = _a.visibility, padding = _a.padding, className = _a.className, children = _a.children, htmlAttributes = __rest(_a, ["spacing", "gap", "grow", "shrink", "basis", "direction", "shouldWrap", "justify", "align", "visibility", "padding", "className", "children"]);
    return (React.createElement("div", __assign({}, htmlAttributes, { ref: ref, className: className }), children));
}))(function (_a) {
    var spacing = _a.spacing, gap = _a.gap, grow = _a.grow, shrink = _a.shrink, basis = _a.basis, direction = _a.direction, shouldWrap = _a.shouldWrap, justify = _a.justify, align = _a.align, visibility = _a.visibility, padding = _a.padding;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  "], ["\n    ", "\n    ", "\n    ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  "])), responsiveProp(visibility, true, function (val) { return "display: ".concat(val ? 'flex' : 'none', ";"); }), responsiveProp([spacing, direction], [undefined, undefined], function (val, dir) {
        return val &&
            "\n    & > *:not(:last-child) {\n      margin: ".concat(spacingStyle(val, dir), ";\n    }\n  ");
    }), responsiveProp(gap, undefined, function (val) { return val && "gap: ".concat(sp[val], ";"); }), responsiveProp(grow, undefined, function (val) {
        return val !== undefined ? "flex-grow: ".concat(val, ";") : undefined;
    }), responsiveProp(shrink, undefined, function (val) {
        return val !== undefined ? "flex-shrink: ".concat(val, ";") : undefined;
    }), responsiveProp(basis, undefined, function (val) { return val && "flex-basis: ".concat(val, ";"); }), responsiveProp(direction, undefined, function (val) { return val && "flex-direction: ".concat(val, ";"); }), responsiveProp(shouldWrap, false, function (val) {
        if (val === undefined)
            return undefined;
        return val ? 'flex-wrap: wrap;' : 'flex-wrap: nowrap;';
    }), responsiveProp(justify, undefined, function (val) { return val && "justify-content: ".concat(flexJustify(val), ";"); }), responsiveProp(align, undefined, function (val) { return val && "align-items: ".concat(flexAlign(val), ";"); }), responsiveProp(padding, undefined, function (val) { return val && "padding: ".concat(sp[val], ";"); }));
});
Layout.propTypes = {
    spacing: responsivePropTypes(PropTypes.oneOf([
        'none',
        'xxx-small',
        'xx-small',
        'x-small',
        'small',
        'medium',
        'large',
        'x-large',
        'xx-large',
    ])),
    gap: responsivePropTypes(PropTypes.oneOf([
        'none',
        'xxx-small',
        'xx-small',
        'x-small',
        'small',
        'medium',
        'large',
        'x-large',
        'xx-large',
    ])),
    // @ts-ignore
    grow: responsivePropTypes(PropTypes.number),
    // @ts-ignore
    shrink: responsivePropTypes(PropTypes.number),
    // @ts-ignore
    basis: responsivePropTypes(PropTypes.string),
    // @ts-ignore
    direction: responsivePropTypes(PropTypes.oneOf([
        'column',
        'column-reverse',
        'row',
        'row-reverse',
    ])),
    // @ts-ignore
    shouldWrap: responsivePropTypes(PropTypes.bool),
    // @ts-ignore
    justify: responsivePropTypes(PropTypes.oneOf([
        'start',
        'end',
        'center',
        'between',
        'around',
        'evenly',
    ])),
    // @ts-ignore
    align: responsivePropTypes(PropTypes.oneOf([
        'start',
        'end',
        'center',
        'stretch',
        'baseline',
    ])),
    // @ts-ignore
    visibility: responsivePropTypes(PropTypes.bool),
    padding: responsivePropTypes(PropTypes.oneOf([
        'none',
        'xxx-small',
        'xx-small',
        'x-small',
        'small',
        'medium',
        'large',
        'x-large',
        'xx-large',
    ])),
    className: PropTypes.string,
    children: PropTypes.node,
};
var templateObject_1;
//# sourceMappingURL=Layout.js.map